import React, { useState, useEffect, useRef } from "react";
import SearchBox from "./components/SearchBox";
import RightMenu from "./components/RightMenu";
import GoogleMapsComponent from "components/GoogleMapsComponent";
import "./index.scss";
import { ChangeEventValue } from "google-map-react";
import api from "api";
import {
  normalizeDistricts,
  normalizeExternalFoodAndBeverageCategories,
  normalizeExternalFoodAndBeverageData,
  normalizeExternalFoodAndBeverageDeliveryData,
  normalizeExternalRetailData,
  normalizeHeatMap,
  normalizeNearbyLocationDetail,
  normalizeNearbyLocationSummary,
  normalizePolygon,
  normalizePolygonArea,
  normalizeRadiusZone,
  normalizeSitePlanningPolygon,
  normalizeStaticDemandData,
  normalizeWardDemographics,
  normalizeWards,
} from "./helper/NormalizeLocationData";
import _ from "lodash";
import CustomMarker from "./components/CustomMarker";
import Constant from "constants/index";
import MapToolTips from "./MapToolTips";
import PolygonInfoModal from "./components/PolygonInfoModal";
import PolygonCommentModal from "./components/PolygonCommentModal";
import { getDrawerManager } from "./helper";
import MenuActions from "./components/MenuActions";
import { AreaType } from "Models/map";

let timeout: any = null,
  timeoutHover: any = null;
const asyncTime = 200;

export type MapData = {
  loading: boolean;
  data: any;
};

type MapInputPropsType = {
  latitude?: number;
  longitude?: number;
  mapStyle?: string;
  embedMode?: boolean;
  pinMode?: boolean;
  onConfirmPinLocation?: (point: { lat?: number; lng?: number }) => void;
};

const Map = ({
  latitude,
  longitude,
  mapStyle,
  embedMode,
  pinMode,
  onConfirmPinLocation,
}: MapInputPropsType) => {
  const [radiusPoint, setRadiusPoint] = useState({
    lat: latitude || 10.77653,
    lng: longitude || 106.700981,
  });
  const mapRef = useRef<any>();
  const mapsRef = useRef<any>();
  const currentOverlay = useRef<any>();
  const potentialZones = useRef<Array<any>>([]);
  const radiusZone = useRef<any>();
  const areaZones = useRef<Array<any>>([]);
  const drawerManager = useRef<any>();
  const foodAndBeverageHeatMap = useRef<any>(null);
  const foodAndBeverageDeliveryHeatMap = useRef<any>(null);
  const staticHeatMap = useRef<any>(null);
  const retailHeatMap = useRef<any>(null);
  const [areaType, setAreaType] = useState<AreaType>("ward");
  const [foodAndBeverageLoading, setFoodAndBeverageLoading] = useState(false);
  const [foodAndBeverageDeliveryLoading, setFoodAndBeverageDeliveryLoading] =
    useState(false);
  const [staticLoading, setStaticLoading] = useState(false);
  const [retailLoading, setRetailLoading] = useState(false);
  const [brandObj, setBrandObj] = useState<{ [key: string]: any }>({});

  // map data state
  const [wardData, setWardData] = useState<any>({
    loading: false,
    wards: null,
    districts: null,
    city: null,
    wardDemographics: null,
  });

  const [
    externalFoodAndBeverageCategories,
    setExternalFoodAndBeverageCategories,
  ] = useState<MapData>({ data: null, loading: false });

  const [externalFoodAndBeverageData, setExternalFoodAndBeverageData] =
    useState<MapData>({ data: null, loading: false });

  const [
    externalFoodAndBeverageDeliveryData,
    setExternalFoodAndBeverageDeliveryData,
  ] = useState<MapData>({ data: null, loading: false });

  const [staticDemandData, setStaticDemandData] = useState<MapData>({
    data: null,
    loading: false,
  });

  const [nearbyLocationSummary, setNearbyLocationSummary] = useState<MapData>({
    data: null,
    loading: false,
  });

  const [nearbyLocationDetail, setNearbyLocationDetail] = useState<MapData>({
    data: null,
    loading: false,
  });

  const [sitePlanningPolygon, setSitePlanningPolygon] = useState<MapData>({
    data: null,
    loading: false,
  });

  const [externalRetailData, setExternalRetailData] = useState<MapData>({
    data: null,
    loading: false,
  });

  const [pinLocationMode, setPinLocationMode] = useState(false);
  const [mapBoundary, setMapBoundary] = useState<any>(null);
  const [currentPoint, setCurrentPoint] = useState<{
    lat?: number;
    lng?: number;
  }>({ lat: latitude, lng: longitude });
  const [enableZone, setEnableZone] = useState(false);
  const [isRadiusMode, setRadiusMode] = useState(false);
  const [radiusVal, setRadiusVal] = useState(1000);
  const [enableArea, setEnableArea] = useState(false);
  const [enableFoodAndBeverageData, setEnableFoodAndBeverageData] =
    useState(false);
  const [hoverState, setHoverState] = useState<any>({});
  const [mapTypeId, setMapTypeId] = useState(Constant.mapTypes[0].id);
  const [
    enableFoodAndBeverageDeliveryData,
    setEnableFoodAndBeverageDeliveryData,
  ] = useState(false);
  const [enablePopulate, setEnablePopulate] = useState(false);
  const [enableRetailData, setEnableRetailData] = useState(false);
  const [enableStaticData, setEnableStaticData] = useState(false);
  const [dataDrawing, setDataDrawing] = useState<any>(
    Constant.DEFAULT_GEOJSON_DRAWING
  );
  const [currentMapDrawer, setCurrentMapDrawer] = useState<any>(null);
  const [togglePlanningZone, setTogglePlanningZone] = useState(false);
  const [togglePlanningZoneComment, setTogglePlanningZoneComment] =
    useState(false);
  const [gettingCurrentLocation, setGettingLocation] = useState(false);
  const [viewState, setViewState] = useState({
    latitude: latitude || 10.77653,
    longitude: longitude || 106.700981,
    zoom: 15,
    pitch: 0,
    bearing: 0,
  });
  useEffect(() => {
    setViewState({
      latitude: latitude || 10.77653,
      longitude: longitude || 106.700981,
      zoom: 15,
      pitch: 0,
      bearing: 0,
    });
  }, [latitude, longitude]);
  const [filterLocation, setFilterLocation] = useState<any>({
    selectedLocationType: [],
    selectedBrand: [],
  });
  const [selectedZone, setSelectedZone] = useState<any>(null);
  const debounceFilterLocation = useDebounce(filterLocation, 500);
  useEffect(() => {
    drawerManager?.current?.setDrawingMode(
      currentMapDrawer ? currentMapDrawer.name : null
    );
  }, [currentMapDrawer]);
  useEffect(() => {
    mapRef?.current?.setMapTypeId(mapTypeId);
  }, [mapTypeId]);
  useEffect(() => {
    document.title = "LISA Planning Map";
    document.addEventListener("keydown", escFunction, false);
    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);
  const escFunction = (event: any) => {
    if (event.keyCode === 27) {
      setCurrentMapDrawer(null);
    }
  };
  useEffect(() => {
    setNearbyLocationDetail((data) => ({ ...data, loading: true }));
    api
      .getNearbyLocationDetail(mapBoundary, getFilter(debounceFilterLocation))
      .then((res: any) => {
        setNearbyLocationDetail({
          loading: false,
          data: normalizeNearbyLocationDetail(res),
        });
      });
  }, [debounceFilterLocation]);
  useEffect(() => {
    addRadiusZone(isRadiusMode, radiusPoint, radiusVal);
  }, [isRadiusMode, radiusPoint, radiusVal]);
  useEffect(() => {
    if (isRadiusMode && radiusPoint.lat && radiusPoint.lng) {
      handleGetDataByRadius();
    }
  }, [isRadiusMode, radiusPoint]);
  useEffect(() => {
    toggleZoneMap(enableZone);
  }, [enableZone, sitePlanningPolygon?.data]);
  useEffect(() => {
    if (enableArea || enablePopulate) {
      importAreaZone();
    }
    toggleAreaMap(enableArea, enablePopulate);
  }, [
    enableArea,
    enablePopulate,
    wardData?.wards,
    wardData?.districts,
    areaType,
  ]);
  const toggleRetailHeatMap = async (enable: boolean) => {
    if (!enable) {
      setRetailLoading(false);
      retailHeatMap?.current?.setMap(null);
    } else {
      setRetailLoading(true);
      const dataRetail = await api.getRetailList(mapBoundary);
      setRetailLoading(false);
      const heatMapRetail =
        dataRetail?.retail_demand?.map?.(
          normalizeHeatMap(mapsRef?.current?.LatLng)
        ) || [];
      const HeatMapLayer = mapsRef?.current?.visualization?.HeatmapLayer;
      if (HeatMapLayer) {
        retailHeatMap.current = new HeatMapLayer({
          data: heatMapRetail,
          options: {
            radius: Constant.HeatMapRadius,
            gradient: Constant.RetailGradient,
          },
        });
        retailHeatMap.current?.setMap(mapRef?.current);
      }
    }
  };
  const toggleStaticHeatMap = async (enable: boolean) => {
    if (!enable) {
      setStaticLoading(false);
      staticHeatMap?.current?.setMap(null);
    } else {
      setStaticLoading(true);
      let dataStatic;
      if (isRadiusMode && radiusPoint.lat && radiusPoint.lng) {
        dataStatic = await api.getStaticListByRadius({
          latitude: radiusPoint.lat,
          longitude: radiusPoint.lng,
          radius: radiusVal / 1000,
        });
      } else {
        dataStatic = await api.getStaticList(mapBoundary);
      }
      setStaticLoading(false);
      const heatMapStatic =
        dataStatic?.static_demand_transactions?.map?.(
          normalizeHeatMap(mapsRef?.current?.LatLng)
        ) || [];
      const HeatMapLayer = mapsRef?.current?.visualization?.HeatmapLayer;
      if (HeatMapLayer) {
        staticHeatMap.current = new HeatMapLayer({
          data: heatMapStatic,
          options: {
            radius: Constant.HeatMapRadius,
            gradient: Constant.staticGradient,
          },
        });
        staticHeatMap.current?.setMap(mapRef?.current);
      }
    }
  };
  const toggleFoodAndBeverageHeatMap = async (enable: boolean) => {
    if (!enable) {
      setFoodAndBeverageLoading(false);
      foodAndBeverageHeatMap?.current?.setMap(null);
    } else {
      setFoodAndBeverageLoading(true);
      let dataFB;
      if (isRadiusMode && radiusPoint.lat && radiusPoint.lng) {
        dataFB = await api.getExternalFoodAndBeverageListByRadius({
          latitude: radiusPoint.lat,
          longitude: radiusPoint.lng,
          radius: radiusVal / 1000,
        });
      } else {
        dataFB = await api.getExternalFoodAndBeverageList(mapBoundary);
      }
      setFoodAndBeverageLoading(false);
      const heatMapFB =
        dataFB?.food_and_beverage_transactions?.map?.(
          normalizeHeatMap(mapsRef?.current?.LatLng)
        ) || [];
      const HeatMapLayer = mapsRef?.current?.visualization?.HeatmapLayer;
      if (HeatMapLayer) {
        foodAndBeverageHeatMap.current = new HeatMapLayer({
          data: heatMapFB,
          options: {
            radius: Constant.HeatMapRadius,
            gradient: Constant.FoodAndBeverageGradient,
          },
        });
        foodAndBeverageHeatMap.current?.setMap(mapRef?.current);
      }
    }
  };
  const toggleFoodAndBeverageDeliveryHeatMap = async (enable: boolean) => {
    if (enable) {
      setFoodAndBeverageDeliveryLoading(true);
      let dataFBDelivery;
      if (isRadiusMode && radiusPoint.lat && radiusPoint.lng) {
        dataFBDelivery =
          await api.getExternalFoodAndBeverageDeliveryListByRadius({
            latitude: radiusPoint.lat,
            longitude: radiusPoint.lng,
            radius: radiusVal / 1000,
          });
      } else {
        dataFBDelivery = await api.getExternalFoodAndBeverageDeliveryList(
          mapBoundary
        );
      }
      setFoodAndBeverageDeliveryLoading(false);
      const heatMapFBDelivery =
        dataFBDelivery?.food_and_beverage_delivery_transactions?.map?.(
          normalizeHeatMap(mapsRef?.current?.LatLng)
        ) || [];
      const HeatMapLayer = mapsRef?.current?.visualization?.HeatmapLayer;
      if (HeatMapLayer) {
        foodAndBeverageDeliveryHeatMap.current = new HeatMapLayer({
          data: heatMapFBDelivery,
          options: {
            radius: Constant.HeatMapRadius,
          },
        });
        foodAndBeverageDeliveryHeatMap.current?.setMap(mapRef?.current);
      }
    } else {
      setFoodAndBeverageDeliveryLoading(false);
      foodAndBeverageDeliveryHeatMap?.current?.setMap(null);
    }
  };
  const getHoverObj = (index: number) => {
    if (areaType == "ward") return wardData?.wards?.[index];
    if (areaType == "district") return wardData?.districts?.[index];
    if (areaType == "city") return wardData?.city?.[index];
  };
  const toggleAreaMap = (enable: boolean, enablePopulate: boolean) => {
    if (!enablePopulate && !enable) {
      areaZones.current?.forEach((zone) => {
        zone?.setMap?.(null);
      });
    } else {
      areaZones.current?.map((zone, index) => {
        mapsRef?.current?.event?.clearInstanceListeners?.(zone);
        if (!enablePopulate) {
          zone?.setOptions({
            fillColor: "transparent",
          });
        } else {
          mapsRef?.current?.event?.addListener(
            zone,
            "mouseover",
            (evt: any) => {
              if (timeoutHover) {
                clearTimeout(timeoutHover);
              }
              setHoverState({
                pointerX: evt.domEvent.x,
                pointerY: evt.domEvent.y,
                wardHoveredObject: getHoverObj(index),
              });
            }
          );
          mapsRef?.current?.event?.addListener(zone, "mouseout", (evt: any) => {
            if (timeoutHover) {
              clearTimeout(timeoutHover);
            }
            timeoutHover = setTimeout(() => {
              setHoverState({});
            }, asyncTime);
          });
          zone?.setOptions({
            fillColor: zone.strokeColor,
          });
        }
        zone?.setMap(mapRef.current);
      });
    }
  };
  const addRadiusZone = (isEnable: boolean, center: any, radius: number) => {
    if (isEnable) {
      if (!radiusZone.current) {
        radiusZone.current = normalizeRadiusZone(mapsRef.current.Circle, {
          center,
          radius: radius,
        });
        mapsRef?.current?.event?.clearInstanceListeners?.(radiusZone.current);
        mapsRef?.current?.event?.addListener(
          radiusZone.current,
          "click",
          onMapClick
        );
      } else {
        radiusZone.current?.setOptions({
          center,
          radius,
        });
      }
      radiusZone.current?.setMap(mapRef.current);
    } else {
      radiusZone.current?.setMap(null);
    }
  };
  const toggleZoneMap = (enable: boolean) => {
    if (enable) {
      potentialZones.current?.map((zone, index) => {
        mapsRef?.current?.event?.clearInstanceListeners?.(zone);
        mapsRef?.current?.event?.addListener(zone, "click", (evt: any) => {
          const planningZone = sitePlanningPolygon?.data?.[index];
          setSelectedZone((selectedZone: any) => {
            if (selectedZone) {
              const previousIndex = sitePlanningPolygon?.data?.findIndex(
                (pZone: any) =>
                  pZone.properties.id == selectedZone.properties.id
              );
              potentialZones.current?.[previousIndex]?.setOptions?.({
                fillOpacity: 0.35,
              });
            }
            return planningZone;
          });
          zone?.setOptions({
            fillOpacity: 0.7,
          });
        });
        mapsRef?.current?.event?.addListener(zone, "mouseover", (evt: any) => {
          const planningZone = sitePlanningPolygon?.data?.[index];
          setHoverState({
            pointerX: evt.domEvent.x,
            pointerY: evt.domEvent.y,
            planningPolygonHoveredObject: planningZone,
          });
        });
        mapsRef?.current?.event?.addListener(zone, "mouseout", (evt: any) => {
          setHoverState({});
        });
        zone?.setMap(mapRef.current);
      });
    } else {
      potentialZones.current?.forEach((zone) => zone?.setMap?.(null));
    }
  };
  const goToSelectedLocation = (selectedItem: any) => {
    if (selectedItem?.geometry?.location) {
      const selectedItemLocation = selectedItem?.geometry?.location;
      navigateToLocation(selectedItemLocation);
    }
  };
  const navigateToLocation = (location: any) => {
    mapRef?.current?.setCenter(location);
    setViewState({
      ...viewState,
      latitude: location.lat,
      longitude: location.lng,
      zoom: 16.5,
      pitch: 0,
      bearing: 0,
    });
    setRadiusPoint({
      lat: location.lat,
      lng: location.lng,
    });
  };
  const onMapClick = (event: any) => {
    // console.log("event", event);
    // console.log("position", event.latLng);
    // console.log("position", event.latLng.lat(), event.latLng.lng());
    const center = { lat: event.latLng.lat(), lng: event.latLng.lng() };
    setRadiusPoint(center);
  };
  const onGoogleMapsApiHandler = (map: any, maps: any) => {
    mapRef.current = map;
    mapsRef.current = maps;
    if (!maps || !maps.drawing) return;
    drawerManager.current = getDrawerManager(maps);
    drawerManager.current?.setMap(map);
    // Add a listener for the click event
    map.addListener("click", onMapClick);
    maps.event.addListener(
      drawerManager.current,
      "overlaycomplete",
      (event: any) => {
        currentOverlay.current = event.overlay;
        // We can access the object we just draw using event.overlay
        // Wether it is a circle, a polygon, anything
        // Refs: https://developers.google.com/maps/documentation/javascript/reference/polygon
        if (event.type == "circle") {
          var radius = event.overlay.getRadius();
          console.log("radius", radius);
        }
        if (event.type == "polygon" || event.type == "polyline") {
          const polygonLatLngArray = event.overlay.getPath().getArray();
          const coordinatesArray = polygonLatLngArray.map((point: any) => {
            return [point.lng(), point.lat()];
          });
          setDataDrawing({
            type: "FeatureCollection",
            features: [
              {
                geometry: { coordinates: [coordinatesArray], type: event.type },
                properties: {},
                type: "Feature",
              },
            ],
          });
          setTogglePlanningZone(true);
        }
      }
    );
  };
  const onChange = (evt: ChangeEventValue) => {
    if (pinLocationMode) {
      setCurrentPoint(evt.center);
      onConfirmPinLocation?.(evt.center);
      return;
    }
    timeout && clearTimeout(timeout);
    timeout = setTimeout(() => {
      const { marginBounds } = evt;
      const { ne, nw, se, sw } = marginBounds;
      const mapBoundary = {
        nw: [nw.lng, nw.lat],
        ne: [ne.lng, ne.lat],
        se: [se.lng, se.lat],
        sw: [sw.lng, sw.lat],
      };
      setMapBoundary(mapBoundary);
      handleGetData(mapBoundary);
    }, asyncTime);
  };
  const getFilter = (filterLocation: any) => {
    const { selectedLocationType, selectedBrand } = filterLocation;
    const filter = selectedLocationType.map((loc: number) => {
      return {
        location_type_id: loc,
        brand_ids: selectedBrand.filter((brd: number) => {
          const locBrands = brandObj?.[`${loc}`] || [];
          return !!locBrands.find((locBrand: any) => locBrand.id == brd);
        }),
      };
    });
    return filter;
  };
  const fetchPlanningZone = async () => {
    const sitePlanningPolygonRes = await api.getSitePlanningPolygon(
      mapBoundary
    );
    const sitePlanningPolygon = normalizeSitePlanningPolygon(
      sitePlanningPolygonRes
    );
    toggleZoneMap(false);
    setSelectedZone(null);
    potentialZones.current = sitePlanningPolygon.map(
      normalizePolygon(mapsRef.current.Polygon)
    );
    setSitePlanningPolygon({
      loading: false,
      data: sitePlanningPolygon,
    });
  };

  const importAreaZone = () => {
    areaZones.current?.forEach((zone) => {
      zone?.setMap?.(null);
    });
    if (areaType == "ward") {
      areaZones.current = wardData?.wards.map(
        normalizePolygonArea(mapsRef.current.Polygon)
      );
    } else if (areaType == "district") {
      areaZones.current = wardData?.districts.map(
        normalizePolygonArea(mapsRef.current.Polygon)
      );
    } else {
      areaZones.current = wardData?.wards.map(
        normalizePolygonArea(mapsRef.current.Polygon)
      );
    }
  };

  const getWardData = async (mapBoundary: any) => {
    setWardData((data: any) => ({ ...data, loading: true }));
    const wardsRes = await api.getWards(mapBoundary);
    const districtRes = await api.getDistricts(mapBoundary);
    if (wardsRes.cancelled) return;
    let wardDemographicsRes = {};
    if (wardsRes.status == "ok") {
      wardDemographicsRes = await api.getWardsDemographics(wardsRes.wards);
    }
    toggleAreaMap(false, false);
    const wards = normalizeWards(wardsRes);
    const districts = normalizeDistricts(districtRes);
    setWardData((data: any) => ({
      ...data,
      loading: false,
      wards,
      districts,
      wardDemographics: normalizeWardDemographics(wardDemographicsRes),
    }));
  };

  const getExternalFoodAndBeverageCategoriesByRadius = async () => {
    setExternalFoodAndBeverageCategories((data) => ({
      ...data,
      loading: true,
    }));
    const externalFoodAndBeverageCategoriesRes =
      await api.getExternalFoodAndBeverageCategoriesByRadius({
        latitude: radiusPoint.lat,
        longitude: radiusPoint.lng,
        radius: radiusVal / 1000,
      });
    if (externalFoodAndBeverageCategoriesRes.cancelled) return;
    setExternalFoodAndBeverageCategories({
      data: normalizeExternalFoodAndBeverageCategories(
        externalFoodAndBeverageCategoriesRes
      ),
      loading: false,
    });
  };

  const getExternalFoodAndBeverageCategories = async (mapBoundary: any) => {
    setExternalFoodAndBeverageCategories((data) => ({
      ...data,
      loading: true,
    }));
    const externalFoodAndBeverageCategoriesRes =
      await api.getExternalFoodAndBeverageCategories(mapBoundary);
    if (externalFoodAndBeverageCategoriesRes.cancelled) return;
    setExternalFoodAndBeverageCategories({
      data: normalizeExternalFoodAndBeverageCategories(
        externalFoodAndBeverageCategoriesRes
      ),
      loading: false,
    });
  };

  const getExternalFoodAndBeverageDataByRadius = async () => {
    setExternalFoodAndBeverageData((data) => ({
      ...data,
      loading: true,
    }));
    const externalFoodAndBeverageDataRes =
      await api.getExternalFoodAndBeverageDataByRadius({
        latitude: radiusPoint.lat,
        longitude: radiusPoint.lng,
        radius: radiusVal / 1000,
      });
    if (externalFoodAndBeverageDataRes.cancelled) return;
    setExternalFoodAndBeverageData({
      data: normalizeExternalFoodAndBeverageData(
        externalFoodAndBeverageDataRes
      ),
      loading: false,
    });
  };

  const getExternalFoodAndBeverageData = async (mapBoundary: any) => {
    setExternalFoodAndBeverageData((data) => ({
      ...data,
      loading: true,
    }));
    const externalFoodAndBeverageDataRes =
      await api.getExternalFoodAndBeverageData(mapBoundary);
    if (externalFoodAndBeverageDataRes.cancelled) return;
    setExternalFoodAndBeverageData({
      data: normalizeExternalFoodAndBeverageData(
        externalFoodAndBeverageDataRes
      ),
      loading: false,
    });
  };

  const getExternalFoodAndBeverageDeliveryDataByRadius = async () => {
    setExternalFoodAndBeverageDeliveryData((data) => ({
      ...data,
      loading: true,
    }));
    const externalFoodAndBeverageDeliveryDataRes =
      await api.getExternalFoodAndBeverageDeliveryDataByRadius({
        latitude: radiusPoint.lat,
        longitude: radiusPoint.lng,
        radius: radiusVal / 1000,
      });
    if (externalFoodAndBeverageDeliveryDataRes.cancelled) return;
    setExternalFoodAndBeverageDeliveryData({
      loading: false,
      data: normalizeExternalFoodAndBeverageDeliveryData(
        externalFoodAndBeverageDeliveryDataRes
      ),
    });
  };

  const getExternalFoodAndBeverageDeliveryData = async (mapBoundary: any) => {
    setExternalFoodAndBeverageDeliveryData((data) => ({
      ...data,
      loading: true,
    }));
    const externalFoodAndBeverageDeliveryDataRes =
      await api.getExternalFoodAndBeverageDeliveryData(mapBoundary);
    if (externalFoodAndBeverageDeliveryDataRes.cancelled) return;
    setExternalFoodAndBeverageDeliveryData({
      loading: false,
      data: normalizeExternalFoodAndBeverageDeliveryData(
        externalFoodAndBeverageDeliveryDataRes
      ),
    });
  };

  const getStaticDemandDataByRadius = async () => {
    setStaticDemandData((data) => ({
      ...data,
      loading: true,
    }));
    const staticDemandDataRes = await api.getStaticDemandDataByRadius({
      latitude: radiusPoint.lat,
      longitude: radiusPoint.lng,
      radius: radiusVal / 1000,
    });
    if (staticDemandDataRes.cancelled) return;
    setStaticDemandData({
      loading: false,
      data: normalizeStaticDemandData(staticDemandDataRes),
    });
  };

  const getStaticDemandData = async (mapBoundary: any) => {
    setStaticDemandData((data) => ({
      ...data,
      loading: true,
    }));
    const staticDemandDataRes = await api.getStaticDemandData(mapBoundary);
    if (staticDemandDataRes.cancelled) return;
    setStaticDemandData({
      loading: false,
      data: normalizeStaticDemandData(staticDemandDataRes),
    });
  };

  const getNearbyLocationSummary = async (mapBoundary: any) => {
    setNearbyLocationSummary((data) => ({
      ...data,
      loading: true,
    }));
    const nearbyLocationSummaryRes = await api.getNearbyLocationSummary(
      mapBoundary
    );
    if (nearbyLocationSummaryRes.cancelled) return;
    setNearbyLocationSummary({
      loading: false,
      data: normalizeNearbyLocationSummary(nearbyLocationSummaryRes),
    });
  };

  const getNearbyLocationDetail = async (mapBoundary: any) => {
    setNearbyLocationDetail((data) => ({
      ...data,
      loading: true,
    }));
    const nearbyLocationDetailRes = await api.getNearbyLocationDetail(
      mapBoundary,
      getFilter(filterLocation)
    );
    if (nearbyLocationDetailRes.cancelled) return;
    setNearbyLocationDetail({
      loading: false,
      data: normalizeNearbyLocationDetail(nearbyLocationDetailRes),
    });
  };

  const getSitePlanningPolygon = async (mapBoundary: any) => {
    setSitePlanningPolygon((data) => ({
      ...data,
      loading: true,
    }));
    const sitePlanningPolygonRes = await api.getSitePlanningPolygon(
      mapBoundary
    );
    if (sitePlanningPolygonRes.cancelled) return;
    const sitePlanningPolygon = normalizeSitePlanningPolygon(
      sitePlanningPolygonRes
    );
    toggleZoneMap(false);
    setSelectedZone(null);
    potentialZones.current = sitePlanningPolygon.map(
      normalizePolygon(mapsRef.current.Polygon)
    );
    setSitePlanningPolygon({
      loading: false,
      data: sitePlanningPolygon,
    });
  };

  const getExternalRetailData = async (mapBoundary: any) => {
    setExternalRetailData((data) => ({
      ...data,
      loading: true,
    }));
    const externalRetailDataRes = await api.getExternalRetailData(mapBoundary);
    if (externalRetailDataRes.cancelled) return;
    setExternalRetailData({
      loading: false,
      data: normalizeExternalRetailData(externalRetailDataRes),
    });
  };

  const handleGetDataByRadius = async () => {
    // console.log("Get data by radius", radiusVal);
    getExternalFoodAndBeverageCategoriesByRadius();
    getExternalFoodAndBeverageDataByRadius();
    getExternalFoodAndBeverageDeliveryDataByRadius();
    getStaticDemandDataByRadius();
  };

  const handleGetData = async (mapBoundary: any) => {
    if (!mapsRef.current) return;
    if (!isRadiusMode) {
      getExternalFoodAndBeverageCategories(mapBoundary);
      getExternalFoodAndBeverageData(mapBoundary);
      getExternalFoodAndBeverageDeliveryData(mapBoundary);
      getStaticDemandData(mapBoundary);
    }
    getWardData(mapBoundary);
    getNearbyLocationSummary(mapBoundary);
    getNearbyLocationDetail(mapBoundary);
    getSitePlanningPolygon(mapBoundary);
    getExternalRetailData(mapBoundary);
  };
  const onFilterLocationType = (
    locType: Array<number>,
    brands: Array<number>
  ) => {
    setFilterLocation({
      selectedLocationType: locType,
      selectedBrand: brands,
    });
  };

  const renderMarkerRadius = () => {
    if (!isRadiusMode || !radiusPoint.lat || !radiusPoint.lng) return null;
    return (
      <CustomMarker
        lat={radiusPoint.lat}
        lng={radiusPoint.lng}
        currentLocation
      />
    );
  };

  const renderCurrentLocation = () => {
    if (!viewState.latitude || !viewState.longitude) return null;
    return (
      <CustomMarker
        lat={viewState.latitude}
        lng={viewState.longitude}
        currentLocation
      />
    );
  };

  const getCurrentPosition = () => {
    setGettingLocation(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setGettingLocation(false);
        navigateToLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (err) => {
        alert("Error code " + err.code + ": " + err.message);
        setGettingLocation(false);
      }
    );
  };

  const renderLocation = (location: any, index: number) => {
    const siteId = location.site_id;
    const to = siteId
      ? `/sitev2/${siteId}`
      : `/market_information/${location.id}`;
    return (
      <CustomMarker
        to={to}
        lat={location.latitude}
        lng={location.longitude}
        location={location}
        key={`${location.id}-${index}`}
        index={index}
        onLeave={() => setHoverState({ nearbyLocationHoveredObject: null })}
        onHover={(evt: any) => {
          setHoverState({
            pointerX: evt?.nativeEvent?.clientX || 0,
            pointerY: evt?.nativeEvent?.clientY || 0,
            nearbyLocationHoveredObject: location,
          });
        }}
      />
    );
  };

  const toggleZone = (enable: boolean) => {
    setEnableZone(enable);
  };

  const toggleArea = (enable: boolean) => {
    setEnableArea(enable);
  };

  const fetchFoodAndBeverageData = () => {
    if (foodAndBeverageLoading) return;
    toggleFoodAndBeverageHeatMap(false);
    toggleFoodAndBeverageHeatMap(true);
  };

  const fetchStaticData = () => {
    if (staticLoading) return;
    toggleStaticHeatMap(false);
    toggleStaticHeatMap(true);
  };

  const fetchFoodAndBeverageDeliveryData = () => {
    if (foodAndBeverageDeliveryLoading) return;
    toggleFoodAndBeverageDeliveryHeatMap(false);
    toggleFoodAndBeverageDeliveryHeatMap(true);
  };

  const fetchRetailData = () => {
    if (retailLoading) return;
    toggleRetailHeatMap(false);
    toggleRetailHeatMap(true);
  };

  const togglePopulate = (enable: boolean) => {
    setEnablePopulate(enable);
  };

  const editPlanningPolygon = () => {
    setTogglePlanningZone(true);
  };

  const toggleSitePlanningCommentUI = () => {
    setTogglePlanningZoneComment(true);
  };

  const onPolygonSaved = () => {
    fetchPlanningZone();
    onCancelled();
  };

  const onCancelled = () => {
    setTogglePlanningZone(false);
    setDataDrawing(Constant.DEFAULT_GEOJSON_DRAWING);
    currentOverlay.current?.setMap(null);
  };

  const openPlanningZoneListing = () => {
    window.open(
      `/planning/list?mapBoundary=${JSON.stringify(mapBoundary)}`,
      "_blank"
    );
  };

  const togglePinLocation = () => {
    setPinLocationMode(!pinLocationMode);
  };

  return (
    <div
      className={`base-map__container${
        embedMode ? " base-map__embed-mode" : ""
      }`}
    >
      <div className="base-map__overlay-menu left">
        <div className="base-map__search-box">
          <SearchBox onItemClick={goToSelectedLocation} />
          <MenuActions
            loading={nearbyLocationDetail.loading}
            gettingCurrentLocation={gettingCurrentLocation}
            getCurrentPosition={getCurrentPosition}
            togglePinLocation={togglePinLocation}
            pinMode={pinMode}
            pinLocationMode={pinLocationMode}
          />
        </div>
      </div>
      {!pinLocationMode && (
        <div className="base-map__overlay-menu right">
          <RightMenu
            openPlanningZoneListing={openPlanningZoneListing}
            areaType={areaType}
            onSelectedAreaType={(type) => setAreaType(type)}
            embedMode={embedMode}
            editPlanningPolygon={editPlanningPolygon}
            toggleSitePlanningCommentUI={toggleSitePlanningCommentUI}
            externalFoodAndBeverageCategories={
              externalFoodAndBeverageCategories
            }
            externalFoodAndBeverageData={externalFoodAndBeverageData}
            externalFoodAndBeverageDeliveryData={
              externalFoodAndBeverageDeliveryData
            }
            externalRetailData={externalRetailData}
            nearbyLocationSummary={nearbyLocationSummary}
            staticDemandData={staticDemandData}
            wardData={wardData}
            selectedLocationType={filterLocation.selectedLocationType}
            selectedBrand={filterLocation.selectedBrand}
            onChange={onFilterLocationType}
            getNewBrand={(brand) =>
              setBrandObj((brandObj) => ({ ...brandObj, ...brand }))
            }
            brandObj={brandObj}
            toggleZone={toggleZone}
            enableZone={enableZone}
            enableArea={enableArea}
            enableFoodAndBeverageData={enableFoodAndBeverageData}
            enableFoodAndBeverageDeliveryData={
              enableFoodAndBeverageDeliveryData
            }
            enablePopulate={enablePopulate}
            enableRetailData={enableRetailData}
            toggleArea={toggleArea}
            fetchFoodAndBeverageData={fetchFoodAndBeverageData}
            fetchFoodAndBeverageDeliveryData={fetchFoodAndBeverageDeliveryData}
            togglePopulate={togglePopulate}
            fetchRetailData={fetchRetailData}
            mapTypeId={mapTypeId}
            onChangeMapType={(id) => setMapTypeId(id)}
            selectedZone={selectedZone}
            currentMapDrawer={currentMapDrawer}
            setCurrentMapDrawer={(drawer) => setCurrentMapDrawer(drawer)}
            enableStaticData={enableStaticData}
            fetchStaticData={fetchStaticData}
            isRadiusMode={isRadiusMode}
            setRadiusMode={setRadiusMode}
            radiusVal={radiusVal}
            setRadiusVal={setRadiusVal}
            onRadiusCompleted={handleGetDataByRadius}
            foodAndBeverageLoading={foodAndBeverageLoading}
            foodAndBeverageDeliveryLoading={foodAndBeverageDeliveryLoading}
            staticLoading={staticLoading}
            retailLoading={retailLoading}
          />
        </div>
      )}
      <div
        className={`base-map__map${embedMode ? " base-map__embed-mode" : ""}`}
      >
        <GoogleMapsComponent
          latitude={viewState.latitude}
          longitude={viewState.longitude}
          onGoogleMapsApiHandler={onGoogleMapsApiHandler}
          onChange={onChange}
        >
          {!pinLocationMode &&
            nearbyLocationDetail?.data?.map?.(renderLocation)}
          {renderCurrentLocation()}
          {renderMarkerRadius()}
        </GoogleMapsComponent>
        {pinLocationMode && (
          <div className="base-map__map-pin-location">
            <CustomMarker currentLocation pinMode />
          </div>
        )}
      </div>
      <MapToolTips state={hoverState} onClose={() => setHoverState({})} />
      {togglePlanningZone && (
        <PolygonInfoModal
          initialIsOpen={togglePlanningZone}
          geoJson={dataDrawing}
          onPolygonSaved={onPolygonSaved}
          planningPolygonToEdit={selectedZone}
          onCancelled={onCancelled}
        />
      )}
      {togglePlanningZoneComment && (
        <PolygonCommentModal
          initialIsOpen={togglePlanningZoneComment}
          planningPolygonToShowComment={selectedZone}
          onCancelled={() => {
            setTogglePlanningZoneComment(false);
          }}
        />
      )}
    </div>
  );
};

function useDebounce(value: any, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);
  return debouncedValue;
}

export default Map;
